/**
 * Islands mount one after another (`appContexts.map(context => context.mount())` in main.ts), so a
 * shared-store write from one island's `onMounted` lands before the next island's setup and drifts
 * that island's hydration render against its server markup. Anything that has to write shared state
 * once the server markup is adopted queues here instead and runs after every island has mounted.
 *
 * Tasks queued after the flush run straight away, so a late app (client-side navigation, the forms
 * app) does not have to know which side of hydration it is on.
 */
const queued: Array<() => void> = [];
let hydrated = false;

const run = (task: () => void) => {
  try {
    task();
  } catch (error) {
    console.error('after-hydration task failed', error);
  }
};

export const runAfterHydration = (task: () => void): void => {
  if (hydrated) {
    run(task);
    return;
  }
  queued.push(task);
};

export const flushAfterHydration = (): void => {
  hydrated = true;
  queued.splice(0).forEach(run);
};

/** Tests only - the module-level state outlives a single case otherwise. */
export const resetAfterHydration = (): void => {
  queued.length = 0;
  hydrated = false;
};
